import { AdminAuthAccount, LoginParams } from '@/services/admin/AdminTypings';
import { TenantAuthAccount } from '@/services/tenant/TenantTypings';
import { MerchantAuthAccount } from '@/services/merchant/MerchantTypings';
import { ConsumerAuthAccount } from '@/services/consumer/ConsumerTypings';
import { ApiAuthAccount } from '@/services/api/ApiTypings';
import TenantPassport from '@/services/tenant/Base/TenantBasePassport';
import MerchantPassport from '@/services/merchant/Base/MerchantBasePassport';
import ConsumerPassport from '@/services/consumer/Base/ConsumerBasePassport';
import ApiPassport from '@/services/api/Base/ApiBasePassport';
import AdminPassport from '@/services/admin/Base/AdminBasePassport';

export declare type AuthAccountType =
  | AdminAuthAccount
  | TenantAuthAccount
  | MerchantAuthAccount
  | ConsumerAuthAccount
  | ApiAuthAccount;

export declare type ProfileProps = {
  authAccount: AuthAccountType;
};

export namespace PassportService {
  /**
   * @summary 登录
   * @secure
   */
  export const login = async (data: LoginParams, params: { [key: string]: any } = {}) => {
    switch (SUP_APP) {
      case 'tenant':
        return TenantPassport.login(data, params);
      case 'merchant':
        return MerchantPassport.login(data, params);
      case 'consumer':
        return ConsumerPassport.login(data, params);
      case 'api':
        return ApiPassport.login(data, params);
      default:
        return AdminPassport.login(data, params);
    }
  };

  /**
   * @summary 注销登录
   * @secure
   */
  export const logout = async (params: { [key: string]: any } = {}) => {
    switch (SUP_APP) {
      case 'tenant':
        return TenantPassport.logout(params);
      case 'merchant':
        return MerchantPassport.logout(params);
      case 'consumer':
        return ConsumerPassport.logout(params);
      case 'api':
        return ApiPassport.logout(params);
      default:
        return AdminPassport.logout(params);
    }
  };

  /**
   * @summary 获取登录信息
   * @secure
   */
  export const auth = async (params: { [key: string]: any } = {}) => {
    switch (SUP_APP) {
      case 'tenant':
        return TenantPassport.auth(params);
      case 'merchant':
        return MerchantPassport.auth(params);
      case 'consumer':
        return ConsumerPassport.auth(params);
      case 'api':
        return ApiPassport.auth(params);
      default:
        return AdminPassport.auth(params);
    }
  };
}

export const login = PassportService.login;
export const logout = PassportService.logout;
export const auth = PassportService.auth;
